import React from 'react'

import { useTheme } from '@material-ui/core'

import { Container, StatusBadge } from './index'
import { FormStatus, PropertyFormTransition } from '../models/Forms/types'
import { usePopover } from '../hooks/usePopover'
import { FormTransitionLogPopover } from './FormTransitionLogPopover'
import { typographyStyle } from '../theme/typographyStyle'

interface Props {
    status: FormStatus
    style?: { container?: React.CSSProperties; text?: React.CSSProperties }
    transitions?: PropertyFormTransition[]
    createdDate?: string
    showTransitions?: boolean
}

const getUiStatus = (status: FormStatus): string => {
    switch (status) {
        case FormStatus.PENDING:
            return 'Pending'
        case FormStatus.COMPLETED:
            return 'Completed'
        case FormStatus.CANCELLED:
            return 'Cancelled'
        case FormStatus.PAUSE:
            return 'Paused'
        default:
            return status
    }
}

export const FormStatusBadge = (props: Props) => {
    const {
        status,
        style,
        transitions,
        createdDate,
        showTransitions = true,
    } = props
    const theme = useTheme()
    const { isOpen, anchorEl, handleOpen, handleClose } = usePopover()

    const text = getUiStatus(status)

    return (
        <Container>
            <StatusBadge
                text={text}
                onClick={
                    showTransitions && transitions
                        ? (e) => {
                              e.stopPropagation()
                              handleOpen(e)
                          }
                        : undefined
                }
                customStyle={{
                    container: {
                        backgroundColor: theme.palette[status].main,
                        minWidth: 80,
                        cursor:
                            showTransitions && transitions
                                ? 'pointer'
                                : 'default',
                        ...style?.container,
                    },
                    text: {
                        ...typographyStyle(theme.typography.caption),
                        ...style?.text,
                    },
                }}
            />

            {showTransitions && transitions && createdDate && (
                <FormTransitionLogPopover
                    open={isOpen}
                    anchorEl={anchorEl}
                    closePopover={(e) => {
                        const event = e as any
                        event.stopPropagation()
                        handleClose()
                    }}
                    transitions={transitions}
                    createdDate={createdDate}
                />
            )}
        </Container>
    )
}
